import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Column } from '@/components/SettingsLayout';
import { Text } from '@/ui';
import {
  PRICING_CHANNEL_ORDER,
  PricingChannel,
} from '@/services/Pricing/pricing-configuration.service';
import styles from './styles.module.css';

type Props = {
  channel: PricingChannel;
  onChange: (channel: PricingChannel) => void;
};

const LABEL_KEYS: Record<PricingChannel, string> = {
  inPerson: 'Pricing.channel_in_person',
  online: 'Pricing.channel_online',
};

const COMMENT_KEYS: Record<PricingChannel, string> = {
  inPerson: 'Pricing.channel_in_person_comment',
  online: 'Pricing.channel_online_comment',
};

const FALLBACK_LABELS: Record<PricingChannel, string> = {
  inPerson: 'In person',
  online: 'Online',
};

const PricingChannelTabs = ({ channel, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    // Column, not a div: `Text` renders inline, so heading and comment would share a line.
    <Column gapSize='12'>
      <div role='tablist' aria-label={t('Pricing.channel_label') ?? 'Payment channel'} className={styles.channelTabs}>
        {PRICING_CHANNEL_ORDER.map((option) => (
          <button
            key={option}
            type='button'
            role='tab'
            aria-selected={option === channel}
            data-testid={`pricing-channel-${option}`}
            className={classNames(styles.channelTab, { [styles.channelTabActive]: option === channel })}
            onClick={() => onChange(option)}
          >
            <Text size='s' weight={option === channel ? 'semi-bold' : 'medium'}>
              {t(LABEL_KEYS[option]) ?? FALLBACK_LABELS[option]}
            </Text>
          </button>
        ))}
      </div>
      <Column>
        <Text size='m' weight='semi-bold'>
          {t(LABEL_KEYS[channel]) ?? FALLBACK_LABELS[channel]}
        </Text>
        <Text size='s' weight='light' color='base-grey'>
          {t(COMMENT_KEYS[channel])}
        </Text>
      </Column>
    </Column>
  );
};

export default PricingChannelTabs;
